export const MIN_CATEGORIES = 3;
export const MAX_CATEGORIES = 8;

export interface PreferencesSelectorHandle {
  /** Selección actual (slugs). El padre la usa al persistir. */
  getSelected: () => string[];
  /** Si la selección actual cumple el rango min/max. */
  isValid: () => boolean;
}

export interface PreferencesSelectorProps {
  /** Deshabilita interacciones — típicamente mientras el padre guarda. */
  disabled?: boolean;
  /** Mensaje de error a mostrar bajo los chips (p. ej. fallo al guardar). */
  errorMessage?: string | null;
  /** Notifica cuando la validez (rango min/max) cambia. */
  onValidityChange?: (isValid: boolean) => void;
}
